// import { Box, Button } from '~shared/ui';

import { useTranslation } from '~shared/lib/i18n';

import NotFound from '~shared/assets/not_found.png';

export const CabinetNotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-7 items-center justify-center h-[80vh]">
      <img src={NotFound} alt="not_found.png" />
      <p>{t('pages.undefined')}</p>
    </div>
  );
};
